// Un turno "a cavallo di mezzanotte" (start_time > end_time) non è rappresentabile
// come una singola riga: calcDeduzioneNottePassiva/overlapsPassiveWindow (nottePassiva.js)
// e le statistiche paga assumono sempre due righe distinte sullo stesso giorno/giorno
// successivo. Queste funzioni pure calcolano lo split, così la stessa logica può
// essere applicata sia in creazione che in modifica di un turno.

export const isOvernightShift = ({ start_time, end_time } = {}) =>
  Boolean(start_time && end_time && start_time > end_time);

const nextDayString = (date) => {
  const next = new Date(date);
  next.setDate(next.getDate() + 1);
  return next.toISOString().split('T')[0];
};

export const buildOvernightSplit = (shift) => ({
  firstShift: { ...shift, end_time: '23:59', shift_period: 'notte' },
  secondShift: {
    ...shift,
    id: null,
    date: nextDayString(shift.date),
    start_time: '00:00',
    shift_period: 'coda_della_notte',
  },
});
